import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { agreementPageSearchSchema } from '&/features/leasing/contracts/lib/contracts-list-search';
import { AGREEMENT_PAGE_PERMISSIONS, LEASING_PATH } from '&/features/leasing/paths';

// The agreement page. The trailing underscore un-nests it from the contract page, which has no <Outlet/>
// (precedent: `contracts_.$contractId_.edit.tsx`). The parent `/leasing` route applies the module switch and
// `leasing:access`; this one adds `agreements:list` and `contracts:list` (the page reads the contract too). On a hard
// refresh permissions may not be loaded yet, so `beforeLoad` lets that through and the page re-checks reactively. It
// carries the contracts list's search, so Back to the contract, then to the list, lands on the list as it was.
export const Route = createFileRoute('/_authenticated/leasing/contracts_/$contractId_/agreements/$agreementId')({
  beforeLoad: ({ context }): void => {
    const { hasPermission, isReady } = context.permissions;
    if (isReady && !AGREEMENT_PAGE_PERMISSIONS.every((code) => hasPermission(code))) {
      throw redirect({ to: LEASING_PATH });
    }
  },
  component: lazyRouteComponent(() => import('&/features/leasing/contracts/pages/agreement-page'), 'AgreementPage'),
  staticData: { dynamic: true },
  validateSearch: (search) => agreementPageSearchSchema.parse(search),
});
